import React, { useState, useMemo, useEffect } from 'react';
import { Chips, ChipsContainer, ItemContainer } from '../../Skills.styles';
import { MainCont, CategoryHeader, Heading, useStyles } from '../SkillComponents.style';
import { Autocomplete } from '@material-ui/lab';
import { talentService } from 'shared/services/talentService';
import { Backdrop, MinusCircleIcon, TextInput, Typography } from '@room-match/shared-ui-components';
import { ISkill, ISkillCategory } from 'shared/interfaces/ISkills';
import SKILLS_DATA from '../../../../../data/Skills.json';
import { CircularProgress } from '@material-ui/core';
import professionList from 'data/new/Professions.json';
import { toProperCase } from 'shared/utils/toProperCase';

const { getProfessions, updateTalent, getSkills } = talentService();
const YourProfessions = () => {
  const classes = useStyles();
  const [searchString, setSearchString] = useState<string>('');
  const { data: professionsData, isLoading: professionsDataIsLoading } = getProfessions(searchString);
  const { mutateAsync: updateSkill, isLoading: updateIsLoading } = updateTalent();
  const { data: skillData, refetch } = getSkills();
  const [selectedProfession, setselectedProfession] = useState<string[]>([]);
  const [saving, setsaving] = useState(false);
  const [skills, setskills] = useState<ISkillCategory[]>(SKILLS_DATA as ISkillCategory[]);
  const [toRemove, settoRemove] = useState('');

  const getProfessionsDataList = useMemo(() => {
    return professionsData ? professionsData.data : [];
  }, [professionsData]);

  useEffect(() => {
    if (!skillData?.data.attributes.skills?.length || typeof skillData?.data.attributes.skills === 'string') {
      return;
    }
    setskills(skillData?.data.attributes.skills || []);
    const prof = skillData.data.attributes.skills?.filter((f) => f.category === 'Professions')[0]?.professions || [];

    setselectedProfession([...prof]);
  }, [skillData]);

  const updateSkills = async (newProf: string[]) => {
    const mData: ISkillCategory[] =
      skills.map((m) => {
        if (m.category === 'Professions') {
          return {
            ...m,
            professions: newProf,
          };
        }
        return m;
      }) || [];

    await updateSkill({
      skills: mData,
    });
    setselectedProfession(newProf);
    refetch().then(() => {
      setskills(mData);
      setsaving(false);
      settoRemove('');
    });
  };

  const handleRemoveChip = (chip: string) => {
    settoRemove(chip);
    const newProf = selectedProfession.filter((f) => f !== chip);
    updateSkills(newProf);
  };

  return (
    <MainCont>
      <CategoryHeader>Your Professions</CategoryHeader>
      <ItemContainer>
        <Heading style={{ marginBottom: 10 }}>Input Professions</Heading>

        <Autocomplete
          id="multiple-tags"
          multiple
          value={selectedProfession}
          loading={professionsDataIsLoading}
          loadingText={'Fetching professions...'}
          classes={{ option: classes.option }}
          // className={classes.autocompleteFix}
          options={
            // getProfessionsDataList?.map((i) => {
            //   return i;
            // }) || []
            professionList
          }
          disableClearable
          getOptionLabel={(label) => label}
          getOptionSelected={(option, value) => option === value}
          fullWidth
          renderTags={() => null}
          limitTags={0}
          onChange={(e, newValue: string[], reason) => {
            if (reason === 'remove-option') return;
            setsaving(true);
            updateSkills(newValue);
          }}
          renderOption={(option: any) => {
            return <p style={{ fontSize: 16 }}>{toProperCase(option)}</p>;
          }}
          renderInput={(params) => {
            return (
              <TextInput
                {...params}
                placeholder={'Select or Type'}
                variant="outlined"
                margin="normal"
                value={searchString}
                onChange={(e) => {
                  if (e) setSearchString(e.target.value);
                }}
              />
            );
          }}
        />
        <ChipsContainer>
          {selectedProfession.map((i) => (
            <Chips>
              {toProperCase(i)}
              {toRemove === i ? (
                <CircularProgress style={{ width: 20, height: 20, marginLeft: 10 }} />
              ) : (
                <MinusCircleIcon style={{ cursor: 'pointer' }} onClick={() => handleRemoveChip(i)} />
              )}
            </Chips>
          ))}
          {updateIsLoading && saving && (
            <Chips style={{ justifyContent: 'center' }}>
              <CircularProgress style={{ width: 20, height: 20 }} />
            </Chips>
          )}
        </ChipsContainer>
      </ItemContainer>

      {/* <Backdrop isLoading={updateIsLoading} /> */}
    </MainCont>
  );
};

export default YourProfessions;
